import React from 'react';

const Footer = () => {
    return (
        <div className='footer'>
            <div className="footerInner">
                <p>copyright &copy; sera all right reserved.</p>
            </div>
        </div>
    );
};

export default Footer;